import React, {
  useMemo,
  forwardRef,
  useContext,
  PropsWithChildren,
} from "react";
import { camelCase } from "lodash-es";
import CONFIGURATION from "../configuration";

require("../../app/startup/configure");

const staticConfiguration = () => {
  const config = {};
  Object.keys(CONFIGURATION).forEach((key) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    config[camelCase(key)] = CONFIGURATION[key];
  });
  return config;
};

type ConfigurationContextProviderProps = {
  configuration?: $TSFixMe;
  testConfiguration?: $TSFixMe;
};

type WithConfigurationProps = {
  configuration?: $TSFixMe;
};

const ConfigurationContext = React.createContext<WithConfigurationProps | null>(
  null,
);

function ConfigurationContextProvider({
  children,
  configuration = {},
  testConfiguration,
}: Readonly<PropsWithChildren<ConfigurationContextProviderProps>>) {
  const context = useMemo(
    () => ({
      configuration: {
        ...staticConfiguration(),
        ...configuration,
        ...testConfiguration,
      },
    }),
    [configuration, testConfiguration],
  );
  return (
    <ConfigurationContext.Provider value={context}>
      {children}
    </ConfigurationContext.Provider>
  );
}

const withConfiguration = <
  T extends WithConfigurationProps = WithConfigurationProps,
>(
  ChildComponent: React.ComponentType<T>,
) => {
  const WrappedComponent = forwardRef<
    $TSFixMe,
    Omit<T, keyof WithConfigurationProps>
  >((props, ref) => (
    <ConfigurationContext.Consumer>
      {
        // istanbul ignore next
        (context = {}) => (
          <ChildComponent {...(props as T)} ref={ref} {...context} />
        )
      }
    </ConfigurationContext.Consumer>
  ));

  WrappedComponent.displayName =
    ChildComponent.displayName ?? ChildComponent.name;
  return WrappedComponent;
};

const useConfiguration = () => {
  const context = useContext(ConfigurationContext);
  // istanbul ignore next
  if (!context) {
    throw new Error(
      "useConfiguration must be used inside a ConfigurationContextProvider",
    );
  }
  return context.configuration;
};

export { ConfigurationContextProvider, withConfiguration, useConfiguration };
